import React from "react";
import { ShieldCheck } from "lucide-react";
export default function CheckoutContent() {
  return <section data-section-id="187453" id="checkout-content" className="bg-background text-foreground py-16 md:py-24 min-h-screen">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="flex flex-col items-center text-center mb-12 md:mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-secondary mb-6">
            <ShieldCheck className="w-8 h-8 text-primary" strokeWidth={1.5} />
          </div>
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-primary mb-4 tracking-tight">
            結帳確認 / SECURE CHECKOUT
          </h1>
          <p className="text-muted-foreground text-lg max-w-2xl font-sans leading-relaxed">
            請確認您的地板選購清單並完成訂購。亨特地板結合自然木質紋理與精準施工工藝，為您呈現最理想的居家質感空間。 / Review your flooring selections and complete your order. Hent's combines natural textures with architectural precision for your ideal living space.
          </p>
        </div>

        <div className="w-full bg-card rounded-md shadow-sm border border-border p-4 md:p-8 lg:p-12">
        </div>
      </div>
    </section>;
}